import React from 'react'
import { Grid, makeStyles } from '@material-ui/core'
import { FonctionInfos } from './FonctionInfos'
import { useHistory, useParams } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { AddItemButtons } from '../../conventions-collectives/themes/add-item-buttons'
import { ParametreListe } from './ParametreListe'
import Fonction from '../../../store/constants/fonction/fonction'
import { useDispatch, useSelector } from 'react-redux'
import { createFonction, updateFonction } from '../../../store/actions/fonction/fonction-action'

const useStyles = makeStyles(theme => ({
  contentRoot: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  popper: {
    ...theme.mixins.gutters(),
    minWidth: 380,
    maxWidth: 600,
    margin: 'auto',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(3),
  },
  container: { maxWidth: '80%', overflowX: 'hidden', margin: 'auto', marginTop: 16 },
  container2: { maxWidth: '80%', overflowX: 'hidden', marginTop: 16 },
  formControl: {
    margin: 0,
    marginTop: 16,
    width: '100%',
  },
  area: {
    '&:focus-visible': {
      border: '#3f51b5 solid',
    },
  },
}))

export const FonctionDetail = () => {
  const { nom } = useParams()
  const history = useHistory()
  const classes = useStyles()
  const dispatch = useDispatch()
  const fonctions = useSelector(state => state.fonctionModule.fonctions)
  const referentiels = useSelector(state => state.referentiels.referentiels)
  let fonctionToEdit = null
  if (nom) {
    fonctionToEdit = fonctions.find(m => m.nom === nom)
    fonctionToEdit.referenceObj = referentiels.find(ref => ref.nom === fonctionToEdit.reference)
  }
  const useFormObj = useForm({
    values: nom ? fonctionToEdit : new Fonction(),
  })

  const onSubmit = data => {
    const dataToSave = { ...data }
    dataToSave.paramList.forEach(param => {
      if (param.valeurOrigineObj && param.valeurOrigineObj.nom) {
        param.valeurOrigine = param.valeurOrigineObj.nom
        delete param.valeurOrigineObj
      }
    })
    if (dataToSave.referenceObj && dataToSave.referenceObj.nom) {
      dataToSave.reference = dataToSave.referenceObj.nom
      delete dataToSave.referenceObj
    }
    if (nom) {
      dataToSave.nom = nom
      dispatch(updateFonction(dataToSave)).then(() => history.push('/fonctions'))
    } else {
      dispatch(createFonction(dataToSave)).then(() => history.push('/fonctions'))
    }
  }

  var onCancel = () => {
    useFormObj.reset()
    history.push('/fonctions')
  }
  return (
    <>
      <br />
      <br />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FonctionInfos classes={classes} useFormObj={useFormObj} isEdit={!!nom} />
        </Grid>
        <Grid item xs={12}>
          <ParametreListe useFormObj={useFormObj} />
        </Grid>
        <Grid container direction="row" justify="flex-end">
          <AddItemButtons
            onSave={useFormObj.handleSubmit(onSubmit)}
            onCancel={onCancel}
            showList={true}
            addDataTest={''}
            cancelDataTest={''}
            saveDataTest={''}
          />
        </Grid>
      </Grid>
    </>
  )
}
